import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Home } from "lucide-react";
import HouseholdNav from "@/components/HouseholdNav";

export default function FamilyReview() {
    const [cadence, setCadence] = useState("monthly");
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/household/family-review", { params: { cadence } })
           .then(r => setData(r.data)).catch(() => setData(null));
    }, [cadence]);

    return (
        <div className="max-w-4xl mx-auto p-6 md:p-8" data-testid="family-review-page">
            <HouseholdNav />
            <div className="mb-4">
                <div className="text-[11px] uppercase tracking-widest text-amber-800 font-semibold flex items-center gap-1.5">
                    <Home size={12} /> Family VAULT Review
                </div>
                <h1 className="font-display text-3xl sm:text-4xl text-stone-900 leading-none mt-2">
                    Everything the family should look at together.
                </h1>
                <p className="text-sm text-stone-500 mt-3 max-w-2xl">
                    Composed from records currently in VAULT. Personal / private information is never
                    included. No financial advice — this is an organisational review.
                </p>
            </div>

            <div className="flex gap-1 border border-stone-200 rounded-full p-1 bg-white w-fit mb-4">
                {[{ k: "monthly", l: "Monthly" }, { k: "quarterly", l: "Quarterly" }].map(o => (
                    <button key={o.k} onClick={() => setCadence(o.k)}
                            className={`px-4 py-1.5 text-[12.5px] font-semibold rounded-full transition-colors ${cadence === o.k ? "bg-stone-900 text-white" : "text-stone-600 hover:bg-stone-100"}`}
                            data-testid={`family-cadence-${o.k}`}>
                        {o.l}
                    </button>
                ))}
            </div>

            {data && (
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    {data.sections.map(s => (
                        <div key={s.kind} className="rounded-xl border border-stone-200 bg-white p-4" data-testid={`family-section-${s.kind.toLowerCase().replace(/\s+/g, "-")}`}>
                            <div className="text-[10.5px] uppercase tracking-widest text-stone-500 font-semibold">{s.kind}</div>
                            <div className="text-2xl font-display tabular-nums text-stone-900 mt-1">{s.count}</div>
                        </div>
                    ))}
                </div>
            )}
            {data && <div className="text-[11px] text-stone-500 mt-4 max-w-2xl">{data.note}</div>}
        </div>
    );
}
